<template>
  <!-- mobile product header -->
  <div id="mobile_fix" v-if="currentBrand" class="mobile-product-header">
    <div v-if="!domainBasedBrand">
      <div class="product-title">
        <div class="brand-name-logo">
          <!--<h4>{{ currentBrand.company_name }}</h4>-->
          <h4 v-if="isStoreBrand">{{ _T_DB(isStoreBrand, 'name') }}</h4>
          <h4 v-else-if="currentStore">{{ _T_DB(currentStore, 'name') }}</h4>
          <h4 v-else>{{ _T_DB(currentBrand, 'company_name') }}</h4>
          <div class="img-part">
            <img
              :src="brandLogoPath"
              @error="brandLogoPath = currentBrand.company_logo"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
        <div>
          <h6 v-if="selectedKitchenType">
            {{ find_goorder_kitchen_type_by_main_id(selectedKitchenType).name }}
          </h6>
          <h6
            class="d-inline-block pl-1"
            v-else
            v-for="(kitchenType, key) in currentBrand.kitchen_type"
            :key="key"
          >
            {{ find_goorder_kitchen_type_by_main_id(kitchenType).name }}
          </h6>
        </div>
      </div>
      <div class="direction">
        <div class="address">
          <div class="icon">
            <svg class="mapPinW" fill="none">
              <use class="fill-primary" xlink:href="#mapPinW" />
            </svg>
          </div>
          <h6>
            {{ _T_DB(currentStore, 'name') }} -{{
              _T_DB(currentStore, 'address')
            }}
            -{{ _T_DB(currentStore, 'city') }} -{{
              _T_DB(currentStore, 'country')
            }}
          </h6>
        </div>
        <a
          @click="$bvModal.show('store-map-popup')"
          data-toggle="modal"
          data-target="#mapModal"
          href="javascript:void(0)"
        >
          {{ _T('get direction') }}</a
        >
      </div>
      <div class="detail">
        <ul v-if="currentStore">
          <!-- <li>
          <svg width="18" height="20">
            <use xlink:href="#box" />
          </svg>
          <span>15-25 {{ _T('minutes') }}</span>
        </li> -->
          <li>
            <svg width="18" height="18">
              <use class="fill-primary" xlink:href="#time" />
            </svg>
            <span>
              {{ deliveryTime(currentStore) }}
            </span>
          </li>
          <li>
            <svg width="18" height="18">
              <use xlink:href="#contact-phone-g" />
            </svg>
            <span>{{ currentStore.phone }}</span>
          </li>
        </ul>
      </div>
      <!-- <div class="dine-btn">
            <a href="javascript:void(0)" class="btn btn-solid">
                  <svg width="22" height="22" >
                    <use  xlink:href="#dineIn" />
                </svg>
                {{_T('dine in')}}
            </a>
        </div> -->
      <StoreMapPop></StoreMapPop>
    </div>
    <div class="product-title"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import StoreMapPop from './StoreMapPopup'

export default {
  name: 'MobileHeader',
  components: {
    StoreMapPop,
  },
  data() {
    return {
      brandLogoPath: '',
    }
  },
  methods: {
    getImage() {
      if (this.currentBrand && this.currentBrand.company_logo) {
        let url = this.currentBrand.company_logo.split('company_logos/')
        this.brandLogoPath = url[0] + 'company_logos/large/' + url[1]
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentBrand',
      'currentStore',
      'deliveryTime',
      'isStoreBrand',
      '_T_DB',
      '_T',
      'domainBasedBrand',
      'find_goorder_kitchen_type_by_main_id',
    ]),
    ...mapState({
      selectedKitchenType: state => state.brand_store.selectedKitchenType,
    }),
  },
}
</script>

<style lang="scss" scoped>
#mobile_fix {
  margin-top: $px100;
}
.mobile-product-header {
  padding: $px15;
  background-color: $white;
  display: none;
  position: relative;
  .product-title {
    padding-bottom: $px8;
    .brand-name-logo {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: $px8;
      .img-part {
        width: $px100;
        padding: $px2;
        border: $px2 solid #eee;
        border-radius: $px5;
      }
    }
    div {
      h4 {
        font-weight: bold;
        font-size: $px18;
        line-height: $px22;
        letter-spacing: 0.02em;
        color: $font-color;
        text-transform: capitalize;
        margin-bottom: $px5;
      }
      h6 {
        font-weight: normal;
        font-size: $px14;
        line-height: $px17;
        color: $light-font;
        text-transform: capitalize;
      }
    }
  }
  .direction {
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-column-gap: $px5;
    margin-bottom: $px10;
    padding-bottom: $px12;
    border-bottom: $px1 dashed $light-border;
    align-items: center;
    .address {
      display: flex;
      align-items: center;
      margin-right: $px8;
      .mapPinW {
        height: $px25;
        width: $px25;
      }
      h6 {
        font-weight: normal;
        font-size: $px12;
        line-height: $px15;
        letter-spacing: 0.02em;
        color: $font-color;
        margin-left: $px3;
        padding-top: $px10;
      }
    }
    a {
      font-weight: 600;
      font-size: $px12;
      line-height: $px15;
      letter-spacing: 0.02em;
      color: $color-tertiary;
      text-transform: capitalize;
    }
  }
  .detail {
    transition: all 0.5s ease;
    li {
      span {
        font-weight: normal;
        font-size: $px11;
        line-height: $px15;
        color: $font-color;
        margin-left: $px5;
      }
      + li {
        margin-left: $px40;
      }
    }
  }
  .dine-btn {
    margin-top: $px10;
    border-top: $px1 dashed $light-border;
    padding-top: $px15;
    .btn-solid {
      width: 100%;
      background-color: $color-secondary;
      text-transform: capitalize;
      position: relative;
      padding: $px8;
      img {
        position: absolute;
        left: $px52;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .logo-sec {
    width: $px50;
    height: $px50;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $white;
    box-shadow: 0px $px4 $px4 rgba($black, 0.1);
    border-radius: 100%;
    position: absolute;
    right: $px20;
    top: -$px20;
    z-index: 1;
    span {
      position: absolute;
      bottom: -$px25;
      font-weight: 600;
      font-size: $px12;
      line-height: $px15;
      color: $font-color;
    }
  }
  &.mobile_fix {
    position: fixed;
    top: $px88;
    width: 100vw;
    background-color: $white;
    z-index: 1;
    .product-title,
    .direction,
    .dine-btn,
    .logo-sec {
      display: none;
    }
    .detail {
      transition: all 0.5s ease;
    }
  }
}
@media (max-width: 767px) {
  .mobile-product-header {
    display: block;
  }
}
@media (max-width: 575px) {
  .mobile-product-header {
    .detail {
      ul {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      li {
        svg {
          display: block;
        }
        span {
          margin-left: 0;
        }
        display: grid;
        grid-template-columns: auto 1fr;
        grid-column-gap: 5px;
      }
    }
  }
}
@media (max-width: 420px) {
  .mobile-product-header {
    .detail {
      ul {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 5px;
      }
      li {
        + li {
          margin-left: $px30;
        }
        display: grid;
        grid-template-columns: auto 1fr;
        grid-column-gap: 5px;
      }
    }
  }
}
@media (max-width: 360px) {
  .mobile-product-header {
    .detail {
      ul {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      li {
        + li {
          margin-left: $px8;
        }
        display: grid;
        grid-template-columns: auto 1fr;
        grid-column-gap: 5px;
      }
    }
  }
}
.body-rtl {
  .mobile-product-header {
    text-align: right;
    ul {
      margin-right: 0;
    }
    li {
      margin-right: $px10;
    }
  }
}
</style>
